import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=33937fe4&scoped=true&"
import script from "./ImageCarousel.vue?vue&type=script&lang=ts&"
export * from "./ImageCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./ImageCarousel.vue?vue&type=style&index=0&id=33937fe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33937fe4",
  null
  
)

export default component.exports